import { render, staticRenderFns } from "./LienEntrepriseRestaurant.vue?vue&type=template&id=3ff6cb28&scoped=true"
import script from "./LienEntrepriseRestaurant.vue?vue&type=script&lang=js"
export * from "./LienEntrepriseRestaurant.vue?vue&type=script&lang=js"
import style0 from "./LienEntrepriseRestaurant.vue?vue&type=style&index=0&id=3ff6cb28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff6cb28",
  null
  
)

export default component.exports